import React from 'react';

interface ResultsComparisonLayoutProps {
  chart: React.ReactNode;
  table: React.ReactNode;
  /** When false, only the table is shown (full width). */
  showChart?: boolean;
}

/** Spider chart on the left, scores table on the right (stacks on small screens). */
export const ResultsComparisonLayout: React.FC<ResultsComparisonLayoutProps> = ({
  chart,
  table,
  showChart = true,
}) => {
  if (!showChart) {
    return <div className="min-w-0">{table}</div>;
  }

  return (
    <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-2 lg:gap-8">
      <div className="min-w-0">{chart}</div>
      <div className="min-w-0 overflow-x-auto">{table}</div>
    </div>
  );
};
